import { concat, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import LineClamp from 'garaje/components/line-clamp';
import dashboardFieldName from 'garaje/helpers/dashboard-field-name';
import type { FilterItem } from 'garaje/models/common';

interface HeaderSelectorOptionSignature<T extends Partial<FilterItem>> {
  Args: {
    index: number;
    option: T;
    toggleHeadersAction: () => void;
  };
}

export default class HeaderSelectorOption<T extends Partial<FilterItem>> extends Component<
  HeaderSelectorOptionSignature<T>
> {
  inputId = guidFor(this);

  @tracked nameWasTruncated = false;

  <template>
    <li data-test-header-selector-option class="flex pt-2 items-center">
      <input
        type="checkbox"
        id={{concat this.inputId "-" @index}}
        data-test-header-name={{dashboardFieldName @option.name}}
        disabled={{@option.disabled}}
        {{on "click" @toggleHeadersAction}}
        checked={{@option.show}}
        class="mr-2"
      />
      <label for={{concat this.inputId "-" @index}} class="sofia-offset">
        <LineClamp
          @handleTruncate={{fn (mut this.nameWasTruncated)}}
          @lines={{2}}
          @lineHeight={{1.25}}
          @text={{dashboardFieldName @option.name}}
        />
      </label>

      {{#if @option.tooltip}}
        <EmberTooltip @side={{if @option.tooltipPosition @option.tooltipPosition "bottom"}} @text={{@option.tooltip}} />
      {{else if this.nameWasTruncated}}
        <EmberTooltip @tooltipClass="break-all" @delay={{400}} @side="top" @text={{dashboardFieldName @option.name}} />
      {{/if}}
    </li>
  </template>
}
